import { render, staticRenderFns } from "./enterprise.vue?vue&type=template&id=04b68e87&scoped=true&"
import script from "./enterprise.vue?vue&type=script&lang=js&"
export * from "./enterprise.vue?vue&type=script&lang=js&"
import style0 from "./enterprise.vue?vue&type=style&index=0&id=04b68e87&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b68e87",
  null
  
)

export default component.exports